import { createSelector } from 'reselect';
import { redux } from 'Core/redux';
import { STORE_KEY, INITIAL_STATE } from './slice';

export const selectState = state => {
  const appState = state || redux.store.getState();
  return appState?.[STORE_KEY] || INITIAL_STATE;
};

export const selectQualityAlertData = state => selectState(state).data;
export const selectQualityAlertLoading = state => selectState(state).loading;
export const selectfetchQualityAlertLoading = state => selectState(state).qualityAlertLoading;
export const selectQualityAlertError = state => selectState(state).error;
export const selectQualityAlertFilterVisible = state => selectState(state).filterVisible;
export const selectQualityAlertFilters = state => selectState(state).filters;
export const selectFilterVisible = state => selectState(state).filterVisible;
export const selectTileView = state => selectState(state).tileView;
export const selectQualityAlertsData = state => selectState(state).qualityAlertsData ;
export const selectFilteredQualityAlerts = createSelector(
  [selectQualityAlertData, selectQualityAlertFilters],
  (data, { searchText }) => {
    return data.filter(entry =>
      Object.keys(entry).some(key =>
        String(entry[key]).toLowerCase().includes(searchText.toLowerCase()),
      ),
    );
  },
);
